import usePairSingleAndReturnAmenityGroups
    from "@CheckOrder/features/amenities/hooks/usePairSingleAndReturnAmenityGroups";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import AmenityGroupSummary
    from "@CheckOrder/features/paymentSummary/features/amenitiesSummary/components/AmenityGroupSummary";

function AmenitiesSummary() {
    const {amenities} = useAppSelector((state) => (state.checkOrder.ticket))
    const {pairedSingleAndReturnAmenities} = usePairSingleAndReturnAmenityGroups(amenities)

    return (
        <>
            {Object.entries(pairedSingleAndReturnAmenities).map(([groupKey, pairedAmenityGroups]) => (
                <AmenityGroupSummary
                    key={groupKey}
                    pairedAmenityGroups={pairedAmenityGroups}
                />
            ))}
        </>
    )
}

export default AmenitiesSummary